import WINDOW from "../../../../utils/window";
import getAxisValue from "./get-axis-value";

/**
 * Scroll continuous (parallax) percents
 * @param {MainClassProps} main
 * @param {TriggerProps} trigger
 * @returns
 */
const getScrollContinuous = (main, trigger) => {
  const axis = getAxisValue(trigger);
  const scroll = /** @type {WindowCoordinatesProps} */ (WINDOW.get("scroll"));
  const bounds = /** @type {BoundsProps} */ (main.bounds);

  if (axis === "x") {
    const wWidth = /** @type {Number} */ (WINDOW.get("width"));
    const scrollX = /** @type {Number} */ (scroll.get("x"));
    const left = /** @type {Number} */ (bounds.get("offset-left"));
    const width = /** @type {Number} */ (bounds.get("width"));

    const position = wWidth + scrollX - left - width / 2 - wWidth / 2;
    return position / (wWidth - (wWidth - width) / 2);
  } else {
    const wHeight = /** @type {Number} */ (WINDOW.get("height"));
    const scrollY = /** @type {Number} */ (scroll.get("y"));
    const top = /** @type {Number} */ (bounds.get("offset-top"));
    const height = /** @type {Number} */ (bounds.get("height"));

    const position = wHeight + scrollY - top - height / 2 - wHeight / 2;
    return position / (wHeight - (wHeight - height) / 2);
  }
};

export default getScrollContinuous;
